import { writable } from 'svelte/store';
import { validateTokenAndFetchUserData } from './auth.js'; // Import your authentication function
import { navigate } from "svelte-routing";
import pb from './pocketbase';

// Store to hold authentication state
export const authStore = writable({
  authData: null,
  isLoading: true,
  error: null,
});

// Initialize authentication
export async function initializeAuth() {
  try {
    // Check if there's a stored token
    const token = pb.authStore.token;
    if (token) {
      // Validate token and fetch user data
      const userData = await validateTokenAndFetchUserData(token);
      if (userData) {
        authStore.update(state => ({
          ...state,
          authData: userData,
          isLoading: false
        }));
        return;
      }
    }
    
    // If no valid token or user data, clear auth state
    authStore.update(state => ({
      ...state,
      authData: null,
      isLoading: false
    }));
  } catch (error) {
    console.error('Auth initialization error:', error);
    authStore.update(state => ({
      ...state,
      error: error.message,
      isLoading: false
    }));
  }
}
